import { PageContainer } from "@/components/layout/PageContainer";
import SuppliersTab from "@/components/inventory/SuppliersTab";
import SupplierModal from "@/components/inventory/SupplierModal";
import { getCurrentShop } from "@/lib/auth";
import { useState, useEffect, useCallback } from "react";

export default function ShopInventorySuppliers() {
  const currentShop = getCurrentShop();

  const [supplierModalOpen, setSupplierModalOpen] = useState(false);
  const [supplierModalMode, setSupplierModalMode] = useState<"create" | "edit">("create");
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleModalSuccess = useCallback(() => {
    setRefreshKey((k) => k + 1);
  }, []);

  useEffect(() => {
    const handleOpenSupplierModal = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (!customEvent.detail || customEvent.detail.shopId === currentShop?.id) {
        setSelectedSupplier(null);
        setSupplierModalMode("create");
        setSupplierModalOpen(true);
      }
    };

    const handleOpenSupplierEditModal = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (!customEvent.detail || customEvent.detail.shopId === currentShop?.id) {
        setSelectedSupplier(customEvent.detail.supplier);
        setSupplierModalMode("edit");
        setSupplierModalOpen(true);
      }
    };

    window.addEventListener("open-supplier-modal", handleOpenSupplierModal);
    window.addEventListener("open-supplier-edit-modal", handleOpenSupplierEditModal);

    return () => {
      window.removeEventListener("open-supplier-modal", handleOpenSupplierModal);
      window.removeEventListener("open-supplier-edit-modal", handleOpenSupplierEditModal);
    };
  }, [currentShop?.id]);

  if (!currentShop) return null;

  return (
    <PageContainer className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-heading font-bold uppercase">
          Proveedores
        </h1>
        <p className="text-muted-foreground mt-2">
          Gestiona los proveedores de tu tienda
        </p>
      </div>

      <SuppliersTab key={refreshKey} shopId={currentShop.id} inventory={[]} />

      <SupplierModal
        open={supplierModalOpen}
        onOpenChange={setSupplierModalOpen}
        shopId={currentShop.id}
        supplier={selectedSupplier}
        mode={supplierModalMode}
        onSuccess={handleModalSuccess}
      />
    </PageContainer>
  );
}
